/* eslint-disable no-console */
import { getEnvs } from './env'

const LOG_PREFIX = '[WebSocket]'
const { wsUrl } = getEnvs()

export const createSocket = (channel: string): WebSocket => {
  const fullUrl = `${wsUrl}${channel}`
  console.log(LOG_PREFIX, 'Creating WebSocket connection', {
    channel,
    wsUrl,
    fullUrl,
    timestamp: new Date().toISOString(),
  })

  try {
    const socket = new WebSocket(fullUrl)
    console.log(LOG_PREFIX, 'WebSocket instance created', {
      channel,
      fullUrl,
      readyState: socket.readyState,
      timestamp: new Date().toISOString(),
    })
    return socket
  } catch (error) {
    console.error(LOG_PREFIX, 'Failed to create WebSocket', {
      channel,
      fullUrl,
      error,
      errorMessage: (error as Error)?.message,
      timestamp: new Date().toISOString(),
    })
    throw error
  }
}
